import { message } from 'antd'
import { IActionEvent } from 'app/api/event/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { Loading } from 'app/components/common/Loading'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { FORMAT_DD_MM_YYYY_HH_MM } from 'app/constant'
import { useCheckInActionByMemberWithLocation } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { DateUtil } from 'parkway-web-common'
import { useEffect, useRef, useState } from 'react'

export const ModalCheckIn = ({ action }: { action?: IActionEvent }) => {
  const refModal = useRef<IRefModal>({})
  const user = useAppSelector(state => state?.user)?.profile
  const { mutateAsync, isLoading: isLoadingSubmit } =
    useCheckInActionByMemberWithLocation()

  const [loading, setLoading] = useState(false)

  const [location, setLocation] = useState<{
    latitude: null | number
    longitude: null | number
  }>({ latitude: null, longitude: null })
  const [error, setError] = useState<string | null>('')

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })
          setError(null)
        },
        error => {
          setError(error.message)
        },
      )
    } else {
      setError('Geolocation is not supported by this browser.')
    }
  }

  useEffect(() => {
    getLocation()
  }, [action?.id])

  const handleSubmit = async () => {
    setLoading(true)
    try {
      if (user?.member?.id) {
        await mutateAsync({
          actionId: action?.id,
          value: true,
          tumId: user?.member?.id,
          location: {
            lat: location?.latitude?.toString(),
            long: location?.longitude?.toString(),
          },
        })
      } else {
        message.error(
          'Bạn không phải đoàn viên? Vui lòng kiểm tra lại thông tin đăng nhập',
        )
      }
    } catch (error) {
      console.log('error', error)
      message.error('Lỗi, vui lòng liên hệ ban tổ chức nếu cần thiết')
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Xác nhận điểm danh"
      buttonOpenModal={
        <BaseButton
          type="primary"
          children="Điểm danh"
          onClick={() => refModal.current?.open?.()}
        />
      }
      handleSubmit={handleSubmit}
      isLoadingConfirm={isLoadingSubmit || loading}
      renderContent={
        <BaseSpace size={8}>
          <BaseSpace size={8}>
            <BaseText
              children={action?.name}
              fontWeight="semibold"
              fontSize="xs"
            />
            <BaseSpace size={8}>
              <BaseText
                children={'Thời gian diễn ra hoạt động'}
                fontWeight="medium"
                opacity="0.7"
              />
              <BaseText
                children={`${DateUtil.formatDate(
                  action?.event?.time_start ?? '',
                  FORMAT_DD_MM_YYYY_HH_MM,
                )} - ${DateUtil.formatDate(
                  action?.event?.time_end ?? '',
                  FORMAT_DD_MM_YYYY_HH_MM,
                )}`}
                colorText="statesGreenColor"
              />
            </BaseSpace>
            <BaseSpace size={8}>
              <BaseText
                children={'Hoạt động thuộc sự kiện'}
                fontWeight="medium"
                opacity="0.7"
              />
              <BaseText
                children={action?.event?.name_event}
                fontWeight="semibold"
                fontSize="xs"
                colorText="otherBlueColor"
              />
            </BaseSpace>
          </BaseSpace>
          
          {loading ? <Loading isAbsolute size="small" /> : null}

          <BaseSpace>
            <BaseCol />

            {error ? (
              <BaseText children={error} colorText="statesRedColor" />
            ) : null}
          </BaseSpace>
        </BaseSpace>
      }
    />
  )
}
